import { TIMES } from '../utils/timeUtil';

export const USER_ANALYTICS_TRACKER_UPDATE = 'USER_ANALYTICS_TRACKER_UPDATE';
export const USER_ANALYTICS_TRACKER_DELETE = 'USER_ANALYTICS_TRACKER_DELETE';
export const USER_ANALYTICS_SET = 'USER_ANALYTICS_SET';

export const USER_ANALYTICS_TRACKER_EXPIRY_MS = 30 * TIMES.DAY;
